// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-65ff86b8] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.action-items[data-v-65ff86b8] {
  display: flex;
  align-items: center;
}
.action-items > button[data-v-65ff86b8] {
  margin-right: 7px;
}
.action-item[data-v-65ff86b8] {
  --open-background-color: var(--color-background-hover, \$action-background-hover);
  position: relative;
  display: inline-block;
}
.action-item.action-item--primary[data-v-65ff86b8] {
  --open-background-color: var(--color-primary-element-hover);
}
.action-item.action-item--secondary[data-v-65ff86b8] {
  --open-background-color: var(--color-primary-element-light-hover);
}
.action-item.action-item--error[data-v-65ff86b8] {
  --open-background-color: var(--color-error-hover);
}
.action-item.action-item--warning[data-v-65ff86b8] {
  --open-background-color: var(--color-warning-hover);
}
.action-item.action-item--success[data-v-65ff86b8] {
  --open-background-color: var(--color-success-hover);
}
.action-item.action-item--tertiary-no-background[data-v-65ff86b8] {
  --open-background-color: transparent;
}
.action-item.action-item--open .action-item__menutoggle[data-v-65ff86b8] {
  background-color: var(--open-background-color);
}
.action-item__menutoggle__icon[data-v-65ff86b8] {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__wrapper {
  border-radius: var(--border-radius-large);
  overflow: hidden;
}
.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__wrapper .v-popper__inner {
  border-radius: var(--border-radius-large);
  padding: 4px;
  max-height: calc(50vh - 16px);
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActions-DL7ZZIjx.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,iEAAiE;AACnE;AACA;EACE,iDAAiD;AACnD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-65ff86b8] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.action-items[data-v-65ff86b8] {\n  display: flex;\n  align-items: center;\n}\n.action-items > button[data-v-65ff86b8] {\n  margin-right: 7px;\n}\n.action-item[data-v-65ff86b8] {\n  --open-background-color: var(--color-background-hover, $action-background-hover);\n  position: relative;\n  display: inline-block;\n}\n.action-item.action-item--primary[data-v-65ff86b8] {\n  --open-background-color: var(--color-primary-element-hover);\n}\n.action-item.action-item--secondary[data-v-65ff86b8] {\n  --open-background-color: var(--color-primary-element-light-hover);\n}\n.action-item.action-item--error[data-v-65ff86b8] {\n  --open-background-color: var(--color-error-hover);\n}\n.action-item.action-item--warning[data-v-65ff86b8] {\n  --open-background-color: var(--color-warning-hover);\n}\n.action-item.action-item--success[data-v-65ff86b8] {\n  --open-background-color: var(--color-success-hover);\n}\n.action-item.action-item--tertiary-no-background[data-v-65ff86b8] {\n  --open-background-color: transparent;\n}\n.action-item.action-item--open .action-item__menutoggle[data-v-65ff86b8] {\n  background-color: var(--open-background-color);\n}\n.action-item__menutoggle__icon[data-v-65ff86b8] {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__wrapper {\n  border-radius: var(--border-radius-large);\n  overflow: hidden;\n}\n.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__wrapper .v-popper__inner {\n  border-radius: var(--border-radius-large);\n  padding: 4px;\n  max-height: calc(50vh - 16px);\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
